import type { MigratedPlotFormProps } from '../../../../forms/formHandlerShared';
import CoupledDimensionPlotForm from '../shared/CoupledDimensionPlotForm';

function OmbrothermicPlotForm(props: MigratedPlotFormProps) {
  return <CoupledDimensionPlotForm {...props} widget="ombrothermic" />;
}

export default OmbrothermicPlotForm;
